var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav-create',{attrs:{"title":_vm.institutionTitle,"add-label":_vm.$t('institution-list-add-institution-btn')}})}
var staticRenderFns = []

export { render, staticRenderFns }